import WinnersList from "./WinnerList";
import EmojiPeopleIcon from "@material-ui/icons/EmojiPeople";
import CreateWinner from "./WinnerCreate";
import EditWinner from "./WinnerEdit";
import ViewWinner from "./WinnerView";

export default {
  list: WinnersList,
  create: CreateWinner,
  edit: EditWinner,
  show: ViewWinner,
  icon: EmojiPeopleIcon,
};
